export const scheduleTypes = {
  oneTime: "One Time",
  individual: "Individual",
  group: "Group",
};

export const canCancelSchedule = {
  yes: "yes",
  no: "no",
};

export const priceTypes = {
  monthly: "Monthly",
  perSession: "PerSession",
};

export const paymentTypes = {
  prePaid: "PrePaid",
  postPaid: "PostPaid",
};

export const billingPeriod = {
  sessinoBased: "Based_On_Session_Events",
  monthEnd: "End_Of_The_Month",
  monthStart: "Beginning_of_the_Month",
};

export const initalFormData = {
  scheduleName: "",
  maxMembers: "",
  duration: "",
  durationMin: "",
  durationHours: "",
  startDate: "",
  price: "",
  priceType: priceTypes.monthly,
  canCancelSchedule: canCancelSchedule.no,
  cancelationGrace: "",
  billingPeriod: billingPeriod.monthEnd,
  ofSessionBilling: "",
  paymentType: paymentTypes.postPaid,
  ofSessionPrePay: "",
  eventDate: "",
  eventTime: "",
};

export const validationNeeded = {
  [scheduleTypes.oneTime]: {
    step2: ["eventDate", "eventTime", "scheduleName", "duration", "price"],
  },
  [scheduleTypes.individual]: {
    step2: ["selectedDays", "scheduleName", "duration", "startDate"],
    step3: ["price"],
  },
  [scheduleTypes.group]: {
    step2: [
      "selectedDays",
      "scheduleName",
      "duration",
      "maxMembers",
      "startDate",
    ],
    step3: ["price"],
  },
};

export const getProgresBarTitles = (t) => ({
  step1: {
    oneTime: {
      title: t("createSchedule.progress.step1_title"),
      subTitle: t("createSchedule.progress.step1_subtitle"),
    },
    group: {
      title: t("createSchedule.progress.step1_title"),
      subTitle: t("createSchedule.progress.step1_subtitle"),
    },
  },
  step2: {
    oneTime: {
      title: t("createSchedule.progress.step2_one_time_title"),
      subTitle: t("createSchedule.progress.step2_one_time_subtitle"),
    },
    group: {
      title: t("createSchedule.progress.step2_group_title"),
      subTitle: t("createSchedule.progress.step2_group_subtitle"),
    },
  },
  step3: {
    oneTime: {
      title: t("createSchedule.progress.step3_one_time_title"),
      subTitle: t("createSchedule.progress.step3_one_time_subtitle"),
    },
    group: {
      title: t("createSchedule.progress.step3_group_title"),
      subTitle: t("createSchedule.progress.step3_group_subtitle"),
    },
  },
  step4: {
    oneTime: {
      title: t("createSchedule.progress.step4_one_time_title"),
      subTitle: t("createSchedule.progress.step4_one_time_subtitle"),
    },
    group: {
      title: t("createSchedule.progress.step4_group_title"),
      subTitle: t("createSchedule.progress.step4_group_subtitle"),
    },
  },
  step5: {
    group: {
      title: t("createSchedule.progress.step5_group_title"),
      subTitle: t("createSchedule.progress.step5_group_subtitle"),
    },
  },
});

// export const progresBarTitles = {
//   step1: {
//     oneTime: {
//       title: t("createSchedule.progress.step1_title"),
//       subTitle: t("createSchedule.progress.step1_subtitle"),
//     },
//     group: {
//       title: t("createSchedule.progress.step1_title"),
//       subTitle: t("createSchedule.progress.step1_subtitle"),
//     },
//   },
//   step2: {
//     oneTime: {
//       title: t("createSchedule.progress.step2_one_time_title"),
//       subTitle: t("createSchedule.progress.step2_one_time_subtitle"),
//     },
//     group: {
//       title: t("createSchedule.progress.step2_group_title"),
//       subTitle: t("createSchedule.progress.step2_group_subtitle"),
//     },
//   },
//   step3: {
//     oneTime: {
//       title: t("createSchedule.progress.step3_one_time_title"),
//       subTitle: t("createSchedule.progress.step3_one_time_subtitle"),
//     },
//     group: {
//       title: t("createSchedule.progress.step3_group_title"),
//       subTitle: t("createSchedule.progress.step3_group_subtitle"),
//     },
//   },
//   step4: {
//     oneTime: {
//       title: t("createSchedule.progress.step4_one_time_title"),
//       subTitle: t("createSchedule.progress.step4_one_time_subtitle"),
//     },
//     group: {
//       title: t("createSchedule.progress.step4_group_title"),
//       subTitle: t("createSchedule.progress.step4_group_subtitle"),
//     },
//   },
//   step5: {
//     group: {
//       title: t("createSchedule.progress.step5_group_title"),
//       subTitle: t("createSchedule.progress.step5_group_subtitle"),
//     },
//   },
// };
